import { comp as _comp } from "@thi.ng/compose";
export function comp(...fns) {
    return _comp.apply(null, fns);
}
